import React, { Component } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiTextField } from '../../../ui';
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
  inputRoot: {
    color: "black",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
  }
}));
export default function FreeSolo(props) {
  const classes = useStyles();
  function handleInputChange(name, event, value) {
    props.subject[name] = value
    props.updateData()
    props.handleChangeForSubjectCode(value)

  }
  function handleChange(name, event, value) {
    let subject = props.subject[name] !== "" ? props.subject[name].toLowerCase() : props.subject[name];
    if (subject !== event.target.value.toLowerCase()){
      props.subject[name] = event.target.value
      props.generatingSubjectCode(event.target.value)
    } 
    props.updateData()
  }

  return (
    <div >
      <Autocomplete
        id="free-solo-demo"
        freeSolo
        classes={classes}
        onChange={(event, value) => handleInputChange('name', event, value)}
        value={props.subject.name}
        options={props.subjectMasterData.subjects.map(option => option.subjectName)}
        renderInput={params => (
          <MuiTextField {...params} fullWidth variant="outlined"
            style={{ width: "100%", height: "100%" }} onBlur={(event) => { handleChange('name', event, event.target.value) }} />
        )}
      />

    </div>
  );

}
